import * as React from 'react';

import { useHistory } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Tooltip from '@material-ui/core/Tooltip';

import { PAGE_ROUTE } from '../../constants';
import API from '../../services/api';
import Copyright from '../../components/copyright';
import CustomGridContainer from '../../components/custom/gridcontainer';
import DialogChangePassword from '../../components/dialog-change-password';

import useStyles from './styles';

const logo = process.env.PUBLIC_URL + '/assets/logos/logo.svg';

export default function Dashboard({ children, drawer, ...props }) {
  const history = useHistory();
  const classes = useStyles();
  const [open] = React.useState(false);
  const [openDialogChangePassword, setOpenDialogChangePassword] = React.useState(false);

  function getName() {
    return API.encryptedSessionStorage.getItem('name', API.encryptedSessionStorage.getTokenData().uid).split(' ')[0];
  }

  function handleExitClick(event) {
    event.preventDefault();
    API.signOut()
      .then(() => {
        history.push(PAGE_ROUTE.SIGNIN);
      })
      .catch((error) => {
        console.log(error.toString());
      });
  }

  function handleClickEdit(event) {
    event.preventDefault();
    setOpenDialogChangePassword(true);
  }

  return (
    <div className={classes.root}>
      <DialogChangePassword open={openDialogChangePassword} setOpen={setOpenDialogChangePassword}></DialogChangePassword>
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <CustomGridContainer container alignItems="center" justifyContent="center">
            <Grid item>
              <img className={classes.logo} src={logo} alt="Logo" />
            </Grid>

            <Grid item>
              <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                Banco Mais
              </Typography>
            </Grid>
          </CustomGridContainer>
          <Typography component="h6" variant="h6" color="inherit">
            {getName()}
          </Typography>

          <Tooltip title={'Alterar senha'}>
            <IconButton color="inherit" onClick={handleClickEdit}>
              <VpnKeyIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title={'Sair'}>
            <IconButton color="inherit" onClick={handleExitClick}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {children}
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
}
